<template>
  <div
    class="ods-logo"
    data-name="OdsLogo">
    <link-tag
      :homeLink="homeLink"
      :router="route"
      :to="to"
      :height="height"
      :width="width">
      <svg
        style="height: 85px"
        :style="{
        'transform-origin': transformOrigin,
        color: secondary ? '#000' : negative ? '#fff' : '#193b47',
        transform: `scale(${size})`
        }" xmlns="http://www.w3.org/2000/svg">
        <template v-if="!onesait">
          <path
            v-if="spaced"
            :transform="dimensionLeft"
            :d="dimensionClosed"
            fill="currentColor"></path>
          <path
            v-else-if="productModule"
            :transform="dimensionLeft"
            :d="dimension"
            fill="currentColor"></path>
          <path
            v-else
            :transform="dimensionLeft"
            :d="dimensionSolo"
            fill="currentColor"></path>
          <text
            fill="currentColor"
            font-family="soho-light"
            font-size="13.689">
            <tspan
              style="text-transform: lowercase"
              x="103.397"
              y="56.6">{{ productModule }}</tspan>
          </text>
          <text
            fill="currentColor"
            font-family="soho-light"
            font-size="24.416">
            <tspan
              style="text-transform: lowercase"
              x="103.397"
              :y="productY">{{ product }}</tspan>
          </text>
        </template>
        <template v-if="!simple">
          <text
            :transform="suitY"
            fill="currentColor"
            font-family="soho-light"
            font-size="13.689">
            <tspan
              style="text-transform: lowercase"
              x=".108"
              y="56.6">{{ suite }}</tspan>
          </text>
          <path
            :transform="onesaitY"
            fill="currentColor"
            d="M61.276 29.606a4.305 4.305 0 0 0-1.509-.908 6.252 6.252 0 0 0-3.934 0 4.328 4.328 0 0 0-1.508.908c-.427.402-.763.89-.984 1.433a4.78 4.78 0 0 0-.328 1.853v4.459c0 1.43.433 2.554 1.289 3.344.856.79 2.013 1.18 3.488 1.184 1.476.003 2.656-.404 3.502-1.184a.125.125 0 0 1 .03-.03v.06-.023l.416 1.026h.833v-8.836a4.807 4.807 0 0 0-.328-1.853 4.121 4.121 0 0 0-.967-1.433zm-.043 7.735a4.918 4.918 0 0 1-.147 1.15 2.574 2.574 0 0 1-.509 1.02c-.278.33-.631.588-1.03.754-.553.22-1.148.32-1.743.296a4.19 4.19 0 0 1-1.738-.299 2.764 2.764 0 0 1-1.03-.747 2.531 2.531 0 0 1-.508-1.027 4.872 4.872 0 0 1-.147-1.147v-4.45c0-1.029.298-1.829.891-2.386.594-.558 1.44-.836 2.532-.843 1.091-.006 1.95.289 2.54.843.59.554.889 1.357.889 2.387v4.449zm22.05 2.505c-.602.536-1.39.813-2.194.77a2.193 2.193 0 0 1-1.741-.655c-.384-.446-.57-1.19-.57-2.296v-7.914h4.203v-1.197h-4.203v-4.02h-1.312v13.21c0 1.377.328 2.42.918 3.095.59.676 1.524 1.03 2.692 1.03 1.167 0 2.049-.289 2.685-.85l-.479-1.173zm-11.702.688V28.541h-4.892v1.18h3.564v10.82h-3.564v1.18h7.54c.04-.003.078-.009.116-.016v-1.151a1.072 1.072 0 0 0-.115-.016l-2.65-.004zm-24.57-5.747l-4.119-1.135a2.23 2.23 0 0 1-1.115-.708 1.61 1.61 0 0 1-.373-1.013 2.075 2.075 0 0 1 .288-1.177c.183-.28.438-.507.738-.656.32-.17.667-.28 1.026-.328.376-.059.757-.088 1.138-.088a4.757 4.757 0 0 1 2.554.603c.61.377.931 1.01.964 1.876v.036H49.4v-.043c-.036-1.259-.495-2.216-1.36-2.843-.866-.626-2.004-.911-3.4-.911a8.164 8.164 0 0 0-1.718.177 4.177 4.177 0 0 0-1.446.61c-.419.28-.763.659-1.004 1.101a3.315 3.315 0 0 0-.38 1.64 2.843 2.843 0 0 0 .616 1.836c.447.54 1.06.915 1.745 1.065l4.137 1.168c.478.12.9.4 1.194.796.249.369.384.802.39 1.246.021.46-.093.916-.328 1.312-.199.31-.476.564-.803.734a3.321 3.321 0 0 1-1.138.328c-.892.12-1.798.1-2.685-.056a3.338 3.338 0 0 1-1.089-.423 2.164 2.164 0 0 1-.705-.737 2.216 2.216 0 0 1-.259-1.145v-.065h-1.311a.508.508 0 0 0 0 .069c.026 1.272.489 2.23 1.37 2.849.882.62 2.023.931 3.433.931a9.643 9.643 0 0 0 1.86-.177 4.334 4.334 0 0 0 1.56-.623 3.393 3.393 0 0 0 1.062-1.197c.27-.564.402-1.184.387-1.81a3.22 3.22 0 0 0-2.505-3.255l-.013.013zm-11.88-5.18a4.305 4.305 0 0 0-1.508-.909 6.252 6.252 0 0 0-3.934 0 4.328 4.328 0 0 0-1.508.908 4.069 4.069 0 0 0-.968 1.433 4.78 4.78 0 0 0-.327 1.853v4.459c0 1.43.432 2.554 1.288 3.344.856.79 2.013 1.18 3.489 1.184.386 0 .772-.032 1.154-.095h.03l.104-.02.115-.023.082-.02.197-.046h.022l.18-.055h.034l.186-.063a4.141 4.141 0 0 0 1.096-.593l.13-.108.024-.017.128-.114c.383-.356.688-.789.895-1.27l-1.174-.708a2.689 2.689 0 0 1-.443.807c-.142.174-.31.326-.495.452a3.184 3.184 0 0 1-.531.299l-.098.042-.043.017-.118.042h-.03a4.1 4.1 0 0 1-.304.08c-.38.074-.767.109-1.155.104a4.19 4.19 0 0 1-1.737-.298 2.764 2.764 0 0 1-1.03-.748c-.244-.3-.418-.65-.508-1.026a4.872 4.872 0 0 1-.148-1.148v-1.442h8.197v-3.036a4.807 4.807 0 0 0-.328-1.853 4.121 4.121 0 0 0-.964-1.433zm-.042 4.918h-6.853v-1.64c0-1.03.299-1.83.892-2.387.594-.557 1.44-.836 2.531-.842 1.092-.007 1.967.288 2.541.842.574.554.889 1.358.889 2.387v1.64zm-16.436-6.128a4.623 4.623 0 0 0-1.118.147 5.01 5.01 0 0 0-1.118.39 4.062 4.062 0 0 0-1.246.915l-.685-1.311h-.62V41.76h1.311v-8.902a2.95 2.95 0 0 1 .263-1.289c.167-.381.41-.725.714-1.01a3.131 3.131 0 0 1 1.099-.655c.454-.16.934-.24 1.416-.233a4.334 4.334 0 0 1 1.721.298c.396.174.75.43 1.036.755.243.3.42.649.519 1.022.09.38.137.768.14 1.158v8.852h1.312v-8.852c0-1.44-.42-2.56-1.246-3.338-.826-.777-2.026-1.17-3.498-1.17zm-9.62 1.213a4.262 4.262 0 0 0-1.508-.908 6.295 6.295 0 0 0-3.935 0 4.311 4.311 0 0 0-1.511.908c-.428.4-.764.89-.984 1.433-.229.59-.34 1.219-.328 1.852v4.456c0 1.433.433 2.557 1.289 3.347.856.79 2.016 1.177 3.492 1.18 1.475 0 2.652-.4 3.492-1.18.839-.78 1.285-1.914 1.285-3.347v-4.456a4.843 4.843 0 0 0-.328-1.852 4.046 4.046 0 0 0-.964-1.433zm-.043 7.737a5.03 5.03 0 0 1-.147 1.148 2.623 2.623 0 0 1-.508 1.026 2.784 2.784 0 0 1-1.033.751 4.262 4.262 0 0 1-1.738.298 4.262 4.262 0 0 1-1.74-.298 2.77 2.77 0 0 1-1.03-.75c-.243-.301-.417-.652-.508-1.027a4.852 4.852 0 0 1-.148-1.148v-4.452c0-1.03.298-1.83.895-2.39s1.44-.833 2.531-.84c1.092 0 1.948.289 2.531.84.584.55.895 1.36.895 2.39v4.452z"></path>
        </template>
      </svg>
    </link-tag>
  </div>
</template>
<script>
import LinkTag from './Tag'
export default {
  name: 'OdsLogo',
  version: '2.0.0',
  category: 'other',
  lastDate: '13/04/2020',
  syncStatus: 'not-applicable',
  components: {
    LinkTag
  },
  props: {
    onesait: {
      type: Boolean,
      default: false
    },
    homeLink: {
      type: Boolean,
      default: true
    },
    simple: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: '/'
    },
    secondary: {
      type: Boolean,
      default: false
    },
    negative: {
      type: Boolean,
      default: false
    },
    suite: {
      type: String
    },
    product: {
      type: String,
      default: 'product'
    },
    productModule: {
      type: String
    },
    width: {
      type: Number,
      default: 275
    },
    height: {
      type: Number,
      default: 85
    },
    size: {
      type: Number,
      default: 1
    },
    spaced: {
      type: Boolean,
      default: false
    },
    transformOrigin: {
      type: String,
      default: '0 0 0'
    }
  },
  data () {
    return {
      route: false,
      productY: '38.57',
      onesaitY: 'translate(0,-2)',
      suitY: 'translate(0,0)',
      dimensionLeft: '',
      dimension: 'M138.585 63.446h2.6v9.112L92.707 83.156V.69l48.534 10.611v9.637h-2.6v-7.544L95.307 3.92v76.006l43.278-9.461z',
      dimensionSolo: 'M141.24,11.3V28.14h-2.6V13.39L95.31,3.92v76l43.28-9.46V55.7h2.6V72.56L92.71,83.16V0.69Z',
      dimensionClosed: 'M92.71,69.69V14.31l30.77,8.94V60.74ZM95.48,18V66l25.23-7.35V25.34Z'
    }
  },
  mounted () {
    if (!this.productModule) {
      this.productY = '48.6'
      this.onesaitY = this.suitY = 'translate(0,7)'
    }
    this.dimensionLeft = this.simple ? 'translate(-90,0)' : 'translate(0,0)'
    this.route = !!this.$router
  }
}
</script>
